import { ChangeEvent, MouseEvent } from 'react';
import { Button } from '@components/button';
import { Grid } from '@mui/material';
import { TextField } from '@components/textField';
import { Dialog } from '@components/dialog';
import { validateUrl } from '@utils/regex';
import { URLValue } from '@components/richTextEditor/URLValue.type';

interface IAddLinkDialog {
  onURLChange: (e: ChangeEvent<HTMLInputElement>) => void;
  urlState: URLValue;
  confirmLink: (e: MouseEvent<HTMLElement>) => void;
  closeLinkDialog: () => void;
  removeLink: (e: MouseEvent<HTMLElement>) => void;
}

export const AddLinkDialog = ({ onURLChange, urlState, confirmLink, closeLinkDialog, removeLink }: IAddLinkDialog) => {
  const dialogTitle = validateUrl(urlState.urlValue.link) ? 'Edit Link' : 'Add Link';

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    removeLink(e);
    closeLinkDialog();
  };

  return (
    <Dialog
      open={urlState.showURLInput}
      title={dialogTitle}
      handleCloseDialog={closeLinkDialog}
      primaryBtnText='Done'
      primaryBtnAction={confirmLink}
      isPrimaryBtnDisabled={!urlState.urlValue.text || !urlState.urlValue.link}
      secondaryBtnText='Exit'
      secondaryBtnAction={closeLinkDialog}
    >
      <Grid size={{ xs: 11 }} sx={{ m: 2 }}>
        <TextField
          name='text'
          variant='outlined'
          inputLabel='Text'
          color='secondary'
          onChange={onURLChange}
          value={urlState.urlValue.text}
          fullWidth
          sx={{ marginBottom: 4 }}
        />
        <TextField
          name='link'
          variant='outlined'
          inputLabel='Link'
          color='secondary'
          onChange={onURLChange}
          value={urlState.urlValue.link}
          fullWidth
        />
      </Grid>
      {urlState.urlValue.link && (
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 2,
          }}
        >
          <Button variant='text' sx={{ fontWeight: '400' }} onClick={handleClick}>
            Remove link
          </Button>
        </Grid>
      )}
    </Dialog>
  );
};
